import api from "@/services/api";

const state = {
  transactions: [],
  transaction: null,
  summary: null
};

const mutations = {
  SET_Transactions(state, transactions) {
    state.transactions = transactions;
  },
  SET_Transaction(state, transaction) {
    state.transaction = transaction;
  },
  SET_Transaction_Summary(state, summary) {
    state.summary = summary;
  }
};

const actions = {
  async getTransactions({ commit }) {
    try {
      const res = await api.get("/transactions");
      commit("SET_Transactions", res.data);
    } catch (error) {
      console.error("Error fetching users:", error.message);
      throw error;
    }
  },

  async getTransaction({ commit }, id) {
    try {
      const res = await api.get(`/transactions/${id}`);
      commit("SET_Transaction", res.data);
      return res.data;
    } catch (error) {
      console.error("Error fetching transaction:", error.message);
      throw error;
    }
  },

  async createTransaction(_, payload) {
    try {
      return await api.post("/transactions", payload);
    } catch (error) {
      console.error("Error creating transaction:", error.message);
      throw error;
    }
  },

  async updateTransaction(_, { id, payload }) {
    try {
      await api.put(`/transactions/${id}`, payload);
    } catch (error) {
      console.error("Error updating transaction:", error.message);
      throw error;
    }
  },

  async deleteTransaction(_, id) {
    try {
      await api.delete(`/transactions/${id}`);
    } catch (error) {
      console.error("Error deleting transaction:", error.message);
      throw error;
    }
  },

  async getTransactionSummary({ commit }) {
    try {
      const res = await api.get(`/transactions/summary`);
      commit("SET_Transaction_Summary", res.data);
    } catch (error) {
      console.error("Error fetching transaction:", error.message);
      throw error;
    }
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};